var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.link)?_c('div',{staticClass:"edit-padding-box"},[_c('iframe',{key:_vm.link,attrs:{"src":_vm.link,"scrolling":"yes"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }